import React from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { getAllJobs } from "../../../../APIs/GetAPIs";
import {
  getAllSavedJobs,
  saveJobCandidate,
  searchJobAPI,
  unSaveJobCandidate,
} from "../../../../APIs/PostAPIS";
import { Images } from "../../../../Assets/0a-exporter";
import Notification from "../../../Portals/Notification/Notification";
import { MainContext } from "../../DashboardContext/Context";
import "./job-listing.style.scss";
import JobListingBody from "./JobListingBody/JobListingBody";
import JobListingSidebar from "./JobListingSidebar/JobListingSidebar";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function JobListing({ type }) {
  let query = useQuery();
  const context = React.useContext(MainContext);
  const [searchTerm, setSearchTerm] = React.useState(null);
  const {
    updateState,
    savedJobs,
    jobListPage,
    setUpSavedJobArray,
    userDetails,
    search,
  } = context;
  const { listType } = useParams();
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [mobileFilter, setMobileFilter] = React.useState(false);
  const [currentJobList, setCurrentJobList] = React.useState(null);
  const [otherJobListInfo, setOtherJobListInfo] = React.useState({ total: "" });
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });
  const [filterConfig, setFilterConfig] = React.useState({
    jobTitle: "",
    city: "",
    country: "",
    jobCategory: "",
    custField4: "",
    jobDescription: "",
    start: "1",
    numOfRecords: "9",
    websitePublish: "",
    custField1: [""],
    jobType: [""],
    minSalary: "0",
    maxSalary: "100000000",
  });
  const setUpJobList = async (filters) => {
    if (currentJobList !== null) {
      setCurrentJobList([]);
    }
    setOtherJobListInfo({ total: 0 });
    setLoading(true);
    try {
      let res = await getAllJobs(filters);
      if (res.data.statusCode === 200) {
        let temp = res.data.data.map((x) => {
          let match = savedJobs.findIndex((y) => {
            return y === x.jobId;
          });
          if (match == -1) {
            return { ...x };
          } else {
            return { ...x, saved: true };
          }
        });
        setCurrentJobList([...temp]);
        setOtherJobListInfo(res.data.totalJobs);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  const setUpSavedJobList = async (schema) => {
    setCurrentJobList([]);
    setLoading(true);
    try {
      let res = await getAllSavedJobs(schema);
      if (res.data.statusCode === 200) {
        let temp = res.data.data.map((x) => {
          return { ...x, saved: true };
        });
        setCurrentJobList([...temp]);
        setOtherJobListInfo(res.data.totalJobs);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const handleSearch = async () => {
    let temp = {
      ...defaultSchema,
      jobTitle: searchTerm,
    };
    setFilterConfig({ ...filterConfig, jobTitle: searchTerm });
    setUpJobList({ ...temp });
  };
  const saveJob = async (obj) => {
    setSaving(true);
    let res = await saveJobCandidate({ jobId: obj.obj.jobId });
    if (res.data.statusCode === 200) {
      setNotification({
        status: true,
        title: `${obj.obj.jobTitle} Job saved`,
      });
      currentJobList[obj.num] = { ...currentJobList[obj.num], saved: true };
      setCurrentJobList([...currentJobList]);
      setUpSavedJobArray();
      setSaving(false);
    } else {
      setSaving(false);
    }
  };
  const unSaveJob = async (obj) => {
    try {
      setSaving(true);
      let res = await unSaveJobCandidate({ jobId: obj.obj.jobId });
      if (res.data.statusCode === 200) {
        if (type === "saved-jobs") {
          currentJobList.splice(obj.num, 1);
        } else {
          currentJobList[obj.num] = {
            ...currentJobList[obj.num],
            saved: false,
          };
        }
        setCurrentJobList([...currentJobList]);
        setUpSavedJobArray();
        setSaving(false);
      } else {
        setSaving(false);
      }
    } catch (error) {}
  };
  React.useEffect(() => {
    if (!type) return;
    updateState("jobListPage", type);
    switch (type) {
      case "recommended-jobs":
        let tokenTwo = localStorage.getItem("userToken");

        if ((userDetails !== null && !userDetails) || !tokenTwo) {
          history.push("/login");
          return;
        }
        if (userDetails?.candidate_relocate) {
          setFilterConfig({
            ...filterConfig,
            start: "1",
            city:
              userDetails?.candidate_location?.[0]?.location_name ||
              userDetails?.candidate_current_location,
          });
          setUpJobList({
            ...defaultSchema,
            city:
              userDetails?.candidate_location?.[0].location_name ||
              userDetails?.candidate_current_location,
          });
        } else {
          setFilterConfig({
            ...filterConfig,
            start: "1",
            city: userDetails?.candidate_current_location,
          });
          setUpJobList({
            ...defaultSchema,
            city: userDetails?.candidate_current_location,
          });
        }

        break;
      case "search":
        setFilterConfig({
          ...filterConfig,
          jobTitle: query.get("jobTitle"),
          city: query.get("location"),
          start: "1",
        });
        let temp = {
          ...defaultSchema,
          jobTitle: query.get("jobTitle"),
          city: query.get("location"),
        };
        setUpJobList({ ...temp });
        break;
      case "all":
        if (loading) return;
        setFilterConfig({
          ...filterConfig,
          city: "",
          start: "1",
        });
        setUpJobList(defaultSchema);

        break;
      case "saved-jobs":
        let token = localStorage.getItem("userToken");

        if ((userDetails !== null && !userDetails) || !token) {
          history.push("/login");
          return;
        }
        setFilterConfig({
          ...filterConfig,
          city: "",
          start: "1",
        });
        if (!userDetails) return;
        setUpSavedJobList(defaultSchema);
        break;

      default:
        break;
    }
  }, [jobListPage, type, userDetails]);
  React.useEffect(() => {
    if (currentJobList === null) return;
    switch (type) {
      case "recommended-jobs":
        setUpJobList({
          ...filterConfig,
        });

        break;
      case "all":
        setUpJobList(filterConfig);

        break;
      case "saved-jobs":
        setUpSavedJobList(filterConfig);
        break;
      case "search":
        setUpJobList(filterConfig);

      default:
        break;
    }
  }, [filterConfig]);

  let timer;

  const handleTimer = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      handleSearch();
    }, 800);
  };

  React.useEffect(() => {
    if (searchTerm === null) return;
    handleTimer();
  }, [searchTerm]);

  return (
    <div className="job-listing-main">
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      <div className="job-listing-search-wrapper">
        <img src={Images.blueDotsTopLeft} />
        <img src={Images.blueDotsBottomRight} />
        <div>
          <input
          value={searchTerm || query.get("jobTitle")}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              clearTimeout(timer);
            }}
            placeholder="Job Title"
          />
          <button onClick={() => handleSearch()}>Search</button>
        </div>
      </div>
      <section className="job-listing-section">
        <div
          onClick={() => setMobileFilter(false)}
          className={`job-listing-sidebar-wrapper ${
            mobileFilter ? "show-filter-overlay" : ""
          }`}
        >
          <JobListingSidebar
            filterConfig={filterConfig}
            setFilterConfig={setFilterConfig}
          />
        </div>

        <div className="job-listing-body-wrapper">
          <JobListingBody
            loading={loading}
            currentJobList={currentJobList}
            setMobileFilter={setMobileFilter}
            listType={listType}
            saveJob={(obj) => {
              saveJob(obj);
            }}
            unSaveJob={(obj) => unSaveJob(obj)}
            filterConfig={filterConfig}
            setFilterConfig={setFilterConfig}
            otherJobListInfo={otherJobListInfo}
          />
        </div>
      </section>
    </div>
  );
}
const defaultSchema = {
  jobTitle: "",
  city: "",
  country: "",
  jobCategory: "",
  custField4: "",
  jobDescription: "",
  start: "1",
  numOfRecords: "9",
  websitePublish: "",
  custField1: [""],
  jobType: [""],
  minSalary: "0",
  maxSalary: "100000000",
};
